import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { getTabLanguage, isTabMultilingual } from './tab-session';

@Injectable()
export class LangInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // The flag and the language are this tab's: the organization selected here and the language chosen here.
        if (!isTabMultilingual(environment._PartnerID)) {
            return next.handle(req);
        }
        const cloned = req.clone({
            params: req.params.set('lang', getTabLanguage())
        });
        return next.handle(cloned);
    }
}
